export const NutritionViews = {
    '1DayView': 'Nutrition1DayView',
    '7DayView': 'Nutrition7DayView',
};
